function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "linearGradient1760",
  x1: 79.375,
  x2: 156.1,
  y1: 224.9,
  y2: 343.96,
  gradientTransform: "matrix(1.196 0 0 1.196 -2.0578 -57.567)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#008582",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#00b3c5",
  stopOpacity: 0.60392,
  offset: 1
})), React.createElement("linearGradient", {
  id: "linearGradient1780",
  x1: 79.375,
  x2: 0.000002,
  y1: 224.9,
  y2: 304.27,
  gradientTransform: "matrix(-1.202 0 0 -1.202 187.88 482.13)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#007e7b",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#00b3c5",
  stopOpacity: 0.60392,
  offset: 1
})), React.createElement("clipPath", {
  id: "clipPath2121"
}, React.createElement("path", {
  d: "m58.917 171.98h67.375a6 6 45 0 1 6 6v67.375a6 6 135 0 1-6 6h-67.375a6 6 45 0 1-6-6v-67.375a6 6 135 0 1 6-6z",
  stroke: "#000",
  strokeWidth: ".26458px"
}), React.createElement("path", {
  d: "m79.375 152.75v-1.2292a6 6 45 0 0-6-6h-40.917a6 6 135 0 0-6 6v40.917a6 6 45 0 0 6 6h1.2292a6 6 135 0 0 6-6v-27.687a6 6 135 0 1 6-6h27.687a6 6 135 0 0 6-6z",
  stroke: "#000",
  strokeWidth: ".26458px"
}), React.createElement("path", {
  d: "m105.83 152.75v-1.2292a6 6 135 0 1 6-6h40.917a6 6 45 0 1 6 6v40.917a6 6 135 0 1-6 6h-1.2292a6 6 45 0 1-6-6v-27.687a6 6 45 0 0-6-6h-27.688a6 6 45 0 1-6-6z",
  stroke: "#000",
  strokeWidth: ".26458px"
}), React.createElement("path", {
  d: "m79.375 270.58v1.2292a6 6 135 0 1-6 6h-40.917a6 6 45 0 1-6-6v-40.917a6 6 135 0 1 6-6h1.2292a6 6 45 0 1 6 6v27.687a6 6 45 0 0 6 6h27.688a6 6 45 0 1 6 6z",
  stroke: "#000",
  strokeWidth: ".26458px"
}), React.createElement("path", {
  d: "m105.83 270.58v1.2292a6 6 45 0 0 6 6h40.917a6 6 135 0 0 6-6v-40.917a6 6 45 0 0-6-6h-1.2292a6 6 135 0 0-6 6v27.687a6 6 135 0 1-6 6h-27.688a6 6 135 0 0-6 6z",
  stroke: "#000",
  strokeWidth: ".26458px"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-26.458 -145.52)"
}, React.createElement("g", {
  clipPath: "url(#clipPath2121)"
}, React.createElement("g", null, React.createElement("path", {
  d: "m13.764 132.29 158.22 158.22h-158.22z",
  fill: "url(#linearGradient1760)"
}), React.createElement("path", {
  d: "m171.98 291.31-159.02-159.02h159.02z",
  fill: "url(#linearGradient1780)"
}))));

var SvgGlyfty = function SvgGlyfty(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "132.29mm",
    height: "132.29mm",
    viewBox: "0 0 132.29 132.29",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGlyfty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/glyfty.51c43c09.svg";
export { ForwardRef as ReactComponent };